
























































































import {Component, Vue, Watch} from "vue-property-decorator";
import QPaginate from "@/common/qPaginate.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import PaginateModel from "@/model/paginate";
import Company from "@/model/company";
import userApi from "@/api/userApi";
import User from "@/model/user";
import click2Top from "@/common/directives/click2Top";
import {namespace} from "vuex-class";
import AccountAdminList from "@/components/account/accountAdminList.vue";
import AccountStaffList from "@/components/account/accountStaffList.vue";
import AccountDetail from "@/components/account/accountDetail.vue";
import AccountCreate from "@/components/account/accountCreate.vue";
import AccountCooperate from "@/components/account/accountCooperate.vue";
import companyApi from "@/api/companyApi";
const authStore = namespace("Auth");
@Component({
  name: "getAccountList",
  directives: {
    click2Top,
  },
  components: {
    QPaginate,
    QTableHeader,
    AccountAdminList,
    AccountStaffList,
    AccountDetail,
    AccountCreate,
    AccountCooperate,
  },
})
export default class getUserList extends Vue {
  @authStore.Getter
  public getCurrentyCompany!: Company;
  @authStore.Getter
  public isAdmin;
  @authStore.Getter
  public isManager;

  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });
  public users: User[] = null;
  public currentCompany: Company = new Company();
  public currentDetailCompany: Company = new Company();

  get getPaginate() {
    return this.pagination;
  }

  get usingCompanyId() {
    return this.getCurrentyCompany ? this.getCurrentyCompany.id : "";
  }

  @Watch("usingCompanyId")
  public async getDetailCurrentCompany() {
    const result = await companyApi.show(this.usingCompanyId);
    this.currentDetailCompany = result.data;
  }

  public search = this.searchInital();

  mounted() {
    this.initalSearch(null);
    this.getUserList();
    this.getDetailCurrentCompany();
  }

  public searchInital() {
    return {
      keyword: null,
      sort: "created_at",
      direction: "desc",
      page: "1",
    };
  }

  @Watch("users")
  public async setCompany() {
    const result = await companyApi.show(this.usingCompanyId);
    this.currentCompany = new Company(result.data);
  }

  public async getUserList() {
    const result = await userApi.indexWithPagination(this.search);
    this.pagination = result.paginate;
    this.users = result.list;
  }

  public clear() {
    this.search = this.searchInital();
    this.changeState();
    this.getUserList();
  }

  public doSearch(query: any): void {
    this.search = { ...this.search, ...query };
    this.getUserList();
  }

  public onSearch(): void {
    this.changeState();
    this.getUserList();
  }

  public changeState(): void {
    let { name, params, query } = this.$router.currentRoute;

    this.search.page = "1";
    query = { ...query, ...this.search };

    this.$router
      .replace({ name: name, params: params, query })
      .catch((error) => {
        console.error(error);
      });
  }

  public initalSearch(parameters: any): void {
    const query = parameters || this.$router.currentRoute.query;
    this.search = {
      ...this.search,
      ...query,
    };
  }

  public createCooperate(cooperationData) {
    (this.$refs.accCooperate as AccountCooperate).show('create', cooperationData);
  }

  public editCooperate(cooperationData) {
    (this.$refs.accCooperate as AccountCooperate).show('edit', cooperationData);
  }

  public createUser() {
    (this.$refs.accCreate as AccountCreate).show();
  }

  public userInfo() {
    (this.$refs.accDetail as AccountDetail).show();
  }

  public getLicenseByCurrentCompany(currentDetailCompany) {
    return (currentDetailCompany && currentDetailCompany.license_is_active) ? currentDetailCompany.license_is_active.license_num : 0;
  }
}
